// @ts-nocheck
// OpenInAppBanner — botão "Abrir no app" pras landings públicas (/c/ e /@).
// Quando o link é aberto num NAVEGADOR mobile (ex.: navegador interno do
// WhatsApp, que ignora Universal/App Links), oferece um atalho que tenta abrir
// o app instalado via custom scheme forjamente://<path>. O appUrlOpen listener
// (platform.ts) capta e navega o WebView pro destino certo — já logado.
//
// Fallback gracioso: se o app não estiver instalado, o scheme não faz nada e o
// usuário continua na própria página web (que já é uma experiência completa).
// Não redireciona pra loja porque os apps ainda estão em teste (não públicos).
import React from 'react';
import { Icon } from './icons';
import { isNativeApp } from './platform';

export const OpenInAppBanner: React.FC<{ path: string }> = ({ path }) => {
  if (typeof window === 'undefined' || isNativeApp()) return null;
  const ua = navigator.userAgent || '';
  const isMobile = /iphone|ipad|ipod|android/i.test(ua);
  if (!isMobile) return null;

  const clean = String(path || '/').replace(/^\/+/, '');
  const openApp = () => {
    try { window.location.href = 'forjamente://' + clean; } catch {}
  };

  return (
    <div style={{ padding: '14px 20px 0' }}>
      <button onClick={openApp} style={{
        width: '100%', padding: '13px', borderRadius: 14,
        background: 'var(--ink)', color: 'var(--paper)',
        fontSize: 14, fontWeight: 600, border: 'none', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
      }}>
        <Icon name="arrow-up" size={15} color="var(--paper)" stroke={2.2}/>
        Abrir no app Forjamente
      </button>
      <div style={{ fontSize: 11.5, color: 'var(--ink-3)', textAlign: 'center', marginTop: 7, lineHeight: 1.4 }}>
        Já tem o app? Abre direto, sem precisar entrar de novo.
      </div>
    </div>
  );
};
